import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
		{
  		path: '',
			redirect: '/Home'
		},
    {
      path: '/Home',
      component: resolve => require(['@/components/Home'], resolve)
    },
    {
      path: '/CollectList',
      component: resolve => require(['@/components/CollectList'], resolve)
    },
    {
    	path: '/Maindetails',
      name: 'Maindetails',
      component: resolve => require(['@/components/news/bkdetail'], resolve)
    },
    {
    	path: '/ArticleDetails',
      name: 'ArticleDetails',
      component: resolve => require(['@/components/ArticleDetails'], resolve)
    },
    {
    	path: '/followList',
      name: 'followList',
      component: resolve => require(['@/components/follow/followList'], resolve)
    },
    {
    	path: '/textDetails',
      name: 'textDetails',
      component: resolve => require(['@/components/follow/textDetails'], resolve)
    },
    {
    	path: '/textList',
      name: 'textList',
      component: resolve => require(['@/components/follow/textList'], resolve)
    },
    {
    	path: '/ActivityCenter',
      name: 'ActivityCenter',
      component: resolve => require(['@/components/ActivityCenter'], resolve)
    },
    {
    	path: '/ActivityCenterend',
      name: 'ActivityCenteendr',
      component: resolve => require(['@/components/ActivityCenterend'], resolve)
    },
    {
    	path: '/AlphaCenter',
      name: 'AlphaCenter',
      component: resolve => require(['@/components/AlphaCenter'], resolve)
    },
    {
    	path: '/CodeList',
      name: 'CodeList',
      component: resolve => require(['@/components/CodeList'], resolve)
    },
    {
      path: '/newhome',
      component: resolve => require(['@/components/newhome'], resolve)
    },
    {
      path: '/investData',
      name: 'investData',
      component: resolve => require(['@/components/investData/index'], resolve)
    },
    {
      path: '/news/home',
      name: 'newsHome',
      component: resolve => require(['@/components/news/home'], resolve)
    },
    {
      path: '/news/newsgzgc',
      name: 'newsgzgc',
      component: resolve => require(['@/components/news/newsgzgc'], resolve)
    },
    {
      path: '/news/lmdetail',
      name: 'lmdetail',
      component: resolve => require(['@/components/news/lmdetail'], resolve)
    },
    {
      path: '/news/alldetail',
      name: 'alldetail',
      component: resolve => require(['@/components/news/alldetail'], resolve)
    },
		{ // 新版问董秘详情
			path: '/newWdmxq',
			name: 'newWdmxq',
			component: resolve => require(['@/components/newWdmxq'], resolve)
		},
		{
      path: '/news/htdetail',
      name: 'htdetail',
      component: resolve => require(['@/components/news/htdetail'], resolve)
    },
		{
      path: '/news/hrjdetail',
      name: 'hrjdetail',
      component: resolve => require(['@/components/Maindetails'], resolve)
    },
		{
      path: '/dzgjd/index',
      name: 'dzgjdIndex',
      component: resolve => require(['@/components/dzgjd/index'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js